const doc = [({"da":({"js":({"admin":({"activities":({"children":({"add_sub_activity":"Tilføj subaktivitet"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;